import React, { ReactElement } from 'react';
import { SortingCenter, SortingCenterUserRole, UserRole } from 'types';
import { SortingCenterChildren } from './SortingCenterChildren';
import { SortingCenterChildrenList } from './SortingCenterChildrenList';

export const generateList = (
  sortingCenterUserRoles: SortingCenterUserRole[] | null,
  selectSortingCenter: (sortingCenter: SortingCenter) => void,
): ReactElement[] => {
  if (!sortingCenterUserRoles) return [<></>];

  const allSortingCentersToRender: ReactElement[] = [];
  const otherRolesSortingCenters: { [key: string]: { sortingCenter: SortingCenter; role: string }[] } = {};

  sortingCenterUserRoles.forEach(({ sortingCenter, role }, index) => {
    if (UserRole.ROLE_ADMIN === role || UserRole.ROLE_SUPPORT === role) {
      /**
       * Si Admin, Admin du Centre de tri et de toutes ses instances.
       * Ne peut pas être Admin que d'une instance seulement.
       * Donc la condition ne devrait JAMAIS échouer.
       */
      if (sortingCenter.childrenSortingCenter && 0 < sortingCenter.childrenSortingCenter?.length) {
        const childrenSortingCenterWithParentObject = sortingCenter.childrenSortingCenter.map(childSortingCenter => {
          childSortingCenter.parentSortingCenter = sortingCenter;
          return childSortingCenter;
        });

        sortingCenter.childrenSortingCenter = childrenSortingCenterWithParentObject;

        allSortingCentersToRender.push(
          sortingCenter.childrenSortingCenter.length === 1 ? (
            <SortingCenterChildren
              key={`${sortingCenter.childrenSortingCenter[0]['@id']}_${index}`}
              sortingCenter={sortingCenter.childrenSortingCenter[0]}
              selectSortingCenter={selectSortingCenter}
              userRole={role}
            />
          ) : (
            <SortingCenterChildrenList
              key={`${sortingCenter['@id']}_${index}`}
              parentSortingCenter={sortingCenter}
              selectSortingCenter={selectSortingCenter}
              isAdmin={true}
            />
          ),
        );
      }
    } else {
      if (sortingCenter.parentSortingCenter) {
        if (!otherRolesSortingCenters[sortingCenter.parentSortingCenter['@id']]) {
          otherRolesSortingCenters[sortingCenter.parentSortingCenter['@id']] = [];
        }

        otherRolesSortingCenters[sortingCenter.parentSortingCenter['@id']].push({
          sortingCenter,
          role,
        });
      }
    }
  });

  let index = 0;

  for (const [, childrenSortingCenters] of Object.entries(otherRolesSortingCenters)) {
    if (!childrenSortingCenters?.[0]?.sortingCenter.parentSortingCenter) continue;

    if (childrenSortingCenters.length === 1) {
      allSortingCentersToRender.push(
        <SortingCenterChildren
          key={`${childrenSortingCenters[0].sortingCenter['@id']}_${index}`}
          sortingCenter={childrenSortingCenters[0].sortingCenter}
          selectSortingCenter={selectSortingCenter}
          userRole={childrenSortingCenters[0].role}
        />,
      );
      continue;
    }

    const parentSortingCenter = childrenSortingCenters[0].sortingCenter.parentSortingCenter;
    parentSortingCenter.childrenSortingCenter = childrenSortingCenters.map(({ sortingCenter }) => sortingCenter);
    const childrenSortingCentersRoles: { [sortingCenterId: string]: string } = {};

    for (const childrenSortingCenter of childrenSortingCenters) {
      childrenSortingCentersRoles[childrenSortingCenter.sortingCenter['@id']] = childrenSortingCenter.role;
    }

    allSortingCentersToRender.push(
      <SortingCenterChildrenList
        key={`${parentSortingCenter['@id']}_${index}`}
        parentSortingCenter={parentSortingCenter}
        selectSortingCenter={selectSortingCenter}
        isAdmin={false}
        childrenSortingCentersRoles={childrenSortingCentersRoles}
      />,
    );

    index++;
  }

  return allSortingCentersToRender;
};
